import { render, staticRenderFns } from "./ed-create-write-object.vue?vue&type=template&id=a8eba6d2&scoped=true&"
import script from "./ed-create-write-object.ts?vue&type=script&lang=ts&"
export * from "./ed-create-write-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-write-object.scss?vue&type=style&index=0&id=a8eba6d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8eba6d2",
  null
  
)

export default component.exports